import React from 'react';
import { useNavigate } from 'react-router-dom';

import './navbar.less';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Space from 'antd/lib/space';
import { BellOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import AlignLeftOutlined from '@ant-design/icons/AlignLeftOutlined';

const Navbar = (props) => {
  const dispatch = useDispatch();
  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
      sidebar: state.distributorReducer.mobile_sidebar,
    };
  });

  let navigate = useNavigate();

  return (
    <Row className={`navBar`} style={{ width: '100%' }}>
      <Col className={'leftIcon mobile_sidebar_menubar'}>
        <AlignLeftOutlined
          onClick={() => dispatch({ type: 'TOGGLE_MOBILE_SIDEBAR' })}
          className={'navbar-icon'}
        />
      </Col>
      <Col
        className={'brand'}
        onClick={() => {
          navigate('/login', { replace: true });
        }}
      >
        HUMBEE
      </Col>
      <Space wrap>
        <div
          className='notification-container'
          onClick={() => navigate('/distributor/notifications')}
        >
          <BellOutlined className={'downMenu'} size={20} />
        </div>
      </Space>

      <Col className={'logoutSection'}>
        <Space wrap>
          <div
            className={'rightMenuCtr'}
            onClick={(e) => {
              e.preventDefault();
              navigate('/profile');
            }}
            // trigger={["click"]}
            // overlay={menu}
          >
            <div>
              {loginUser && loginUser.firstname
                ? loginUser.firstname.charAt(0)
                : 'U'}
            </div>
          </div>
        </Space>
      </Col>
    </Row>
  );
  /*return (
          <nav className="navbar">
              <div className="left-content">
                  <AlignLeftOutlined className={"navbar-icon"}/>
                  <h1>Humbee</h1>
              </div>
              <div className="right-content">

                  <Dropdown overlay={menu} trigger={['click']}>
                      <a  onClick={e => e.preventDefault()}>
                          <DownOutlined className={'rightMenu'}/>
                      </a>
                  </Dropdown>
              </div>
          </nav>
      );*/
};

export default Navbar;
